import React from 'react';
import MarketoForm from 'components/Form/MarketoForm';
import WebinarHeroInfoStrip from './DateStrip';
import { Container, Copy, Form, HeroContainer, Kicker, Title } from './styles';
import { WithUserContext } from 'utils/UserContext';
import LoggedInUserDownload from 'components/Page/Toolbox/LoggedInUserDownload';

const WebinarHero = ({
  type,
  form,
  formSubmitted,
  onFormSuccess,
  shouldRedirect,
  title,
  date,
  time,
  duration,
  userInfo,
}) => {
  return (
    <HeroContainer>
      <Container>
        <Copy>
          <Kicker>{type === 'live' ? 'LIVE WEBINAR' : 'ON-DEMAND WEBINAR'}</Kicker>
          <Title>{title}</Title>
          <WebinarHeroInfoStrip date={date} time={time} duration={duration} />
        </Copy>
        {!userInfo && form && (type === 'live' || !formSubmitted) && (
          <Form>
            <MarketoForm
              affixMobile={false}
              className="webinar-register--side-form"
              width="100%"
              shadow
              formType="Webinar Form"
              showPrivacy={false}
              onSuccess={onFormSuccess}
              shouldRedirect={shouldRedirect || false}
              formId="side-gated-form"
              inlineMarketingForm={form}
              title={form.formTitle || 'Save your spot'}
            />
          </Form>
        )}
        {userInfo && form && type === 'live' && (
          <LoggedInUserDownload
            title={form.formTitle || 'Save your spot'}
            buttonTitle={'Submit'}
            userInfo={userInfo}
            inlineMarketingForm={form}
          />
        )}
      </Container>
    </HeroContainer>
  );
};

export default WithUserContext(WebinarHero);
